import Axios from "axios";
import { API_PaymentQuery } from "../interfaces";
const paymentQuery = async (params: API_PaymentQuery) => {
  const resp = await Axios.get(
    "https://kidsnparty-com-au.ozwearugg.com.au/roben_api/payments/public/api/payments",
    { params }
  );

  return resp.data;
};

export default paymentQuery;
